import { PlanningsDeliveryWithLegRunEntity } from 'src/entities/PlanningsDelivery.entity';
import { PositionEntity } from 'src/entities/PositionEntity';

export type GarageLegs = {
  /** 出発地（車庫）。線の先頭に足す。出さないなら null */
  start: PositionEntity | null;
  /** 帰着地（車庫）。線の末尾に足す。出さないなら null */
  end: PositionEntity | null;
};

const NO_LEGS: GarageLegs = { start: null, end: null };

function positionFrom(lat: string | null | undefined, lng: string | null | undefined): PositionEntity | null {
  if (!lat || !lng) return null;
  const [latitude, longitude] = [parseFloat(lat), parseFloat(lng)];
  if (Number.isNaN(latitude) || Number.isNaN(longitude)) return null;
  return [latitude, longitude];
}

/**
 * ルート線の両端に足す車庫。最終納品先から帰着地までの線が繋がっていなかったので足す。
 *
 * 判定は V3Plans (PlanningMapDeliveryPolylines.presenter.tsx:58-59) と同じ:
 * - 出発: 出庫の operation があるか、未割当（driver なし）なら出す
 * - 帰着: 入庫の operation があるか、未割当かつ「帰庫する」設定なら出す
 *
 * 1 台が複数回転を持つときは最初の回転の前・最後の回転の後にだけ置く。回転ごとに
 * 挟むと、回転の変わり目で車庫を往復する線になる。
 *
 * Why not 帰庫しない勤務で次の勤務まで線を引く（V3Plans はやっている）: /map は行
 * （回転）単位で線を描いており、別の勤務は別の線として既に描かれている。繋ぐと
 * どの線がどの勤務のものか読めなくなる。
 */
export function buildGarageLegs(
  delivery: PlanningsDeliveryWithLegRunEntity | undefined,
  isFirstRotation: boolean,
  isLastRotation: boolean,
): GarageLegs {
  if (!delivery) return NO_LEGS;

  const garage = positionFrom(delivery.garageLatitude, delivery.garageLongitude);
  if (!garage) return NO_LEGS;

  const isUnassigned = delivery.driverId == null;
  const departs = Boolean(delivery.departureOperation) || isUnassigned;
  const returns = Boolean(delivery.arrivalOperation) || (isUnassigned && delivery.returnToBase);

  return {
    start: departs && isFirstRotation ? garage : null,
    end: returns && isLastRotation ? garage : null,
  };
}
